var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, HelpIcon, Spinner, Tag, VariableToken, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import isEqual from 'lodash/isEqual';
import truncate from 'lodash/truncate';
import { PureComponent } from 'react';
import * as React from 'react';
import { RSFieldText } from './rSFieldText';
import styles from './requestSimulator.module.scss';
import { RequestSimulatorFold } from './requestSimulatorFold';
import { RequestSimulatorObjectLine } from './requestSimulatorObjectLine';
export class RequestSimulator extends PureComponent {
    static renderStatus({ name, text, color }) {
        const colorClass = {
            [styles.statusValue]: true,
            [styles.statusValueGreen]: color === 'GREEN',
            [styles.statusValueRed]: color === 'RED',
        };
        return (_jsxs("div", Object.assign({ className: styles.status }, { children: [`${name}: `, _jsx("span", Object.assign({ className: classnames(colorClass) }, { children: text }))] }), name));
    }
    static getDerivedStateFromProps(props, state) {
        const { variables = [] } = props;
        const variableKeys = variables.map((variable) => variable.key);
        if (state.variableKeys &&
            variableKeys.length === state.variableKeys.length &&
            isEqual(variableKeys, state.variableKeys)) {
            return null;
        }
        const variableValues = variableKeys.reduce((acc, key) => {
            if (state.variableValues && state.variableValues[key]) {
                acc[key] = state.variableValues[key];
            }
            else {
                acc[key] = '';
            }
            return acc;
        }, {});
        return {
            variableKeys,
            variableValues,
        };
    }
    constructor(props) {
        super(props);
        this.state = {
            variableKeys: [],
            variableValues: {},
        };
        this.onVariableChange = this.onVariableChange.bind(this);
        this.onSend = this.onSend.bind(this);
    }
    renderTree(data, dataKey = '', nestingLevel = 0, path = '', isLastLine = false) {
        if (data === null) {
            return 'null';
        }
        if (typeof data === 'object') {
            const keys = Object.keys(data);
            const isArray = Array.isArray(data);
            return (_jsx(RequestSimulatorFold, Object.assign({ foldKey: dataKey, isArray: isArray, folded: nestingLevel > 1, isLastLine: isLastLine }, { children: keys.map((key, index) => {
                    let itemPath = path;
                    if (path) {
                        if (isArray) {
                            itemPath += `[${key}]`;
                        }
                        else {
                            itemPath += `.${key}`;
                        }
                    }
                    else {
                        itemPath = key;
                    }
                    return (_jsx(RequestSimulatorObjectLine, { isArray: isArray, objKey: key, path: itemPath, objValue: this.renderTree(data[key], key, nestingLevel + 1, itemPath, index + 1 === keys.length), isLastLine: index + 1 === keys.length }, key));
                }) })));
        }
        if (typeof data === 'boolean') {
            return data ? 'true' : 'false';
        }
        if (typeof data === 'string') {
            if (data.length > 30) {
                return `"${truncate(data, {
                    length: 80,
                    omission: '[…]',
                    separator: /,?\.? +/,
                })}"`;
            }
            return `"${data}"`;
        }
        return data.toString();
    }
    onVariableChange(e, key, value) {
        const { variableValues } = this.state;
        const { onChange } = this.props;
        if (variableValues[key] !== value) {
            this.setState({
                variableValues: Object.assign(Object.assign({}, variableValues), { [key]: value }),
            });
            onChange(e, key, value);
        }
    }
    onSend() {
        const { onSend } = this.props;
        const { variableValues } = this.state;
        onSend(variableValues);
    }
    render() {
        const _a = this.props, { className, data, status, variables, loading, title, helpText, isAligned, onChange, onSend } = _a, otherProps = __rest(_a, ["className", "data", "status", "variables", "loading", "title", "helpText", "isAligned", "onChange", "onSend"]);
        const { variableValues } = this.state;
        const hasVariables = !!(variables && variables.length);
        const hasData = data !== undefined && data !== null;
        const hasStatus = status !== undefined && status !== null;
        const hasDataBlock = hasVariables || hasData || loading;
        const buttonProps = {
            onClick: this.onSend,
            variant: isAligned ? 'primary' : 'secondary',
        };
        const rootClass = classnames({
            [styles.root]: true,
            [styles.rootHasVariables]: hasVariables,
            [styles.rootIsLoading]: loading,
        }, className);
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [_jsxs("div", Object.assign({ className: classnames(styles.topbar, {
                        [styles.topbarAligned]: isAligned,
                        [styles.topbarWithDataBlock]: isAligned && hasDataBlock,
                    }) }, { children: [!!title && (_jsxs("div", Object.assign({ className: styles.title }, { children: [title, !!helpText && _jsx(HelpIcon, { text: helpText })] }))), _jsx(Button, Object.assign({}, buttonProps, { children: "Test request" }))] })), hasDataBlock && (_jsxs("div", Object.assign({ className: styles.requestDataBlock }, { children: [hasVariables && (_jsx("div", Object.assign({ className: styles.variableContainer }, { children: _jsxs("div", Object.assign({ className: styles.variables }, { children: [_jsx("div", Object.assign({ className: classnames(styles.variableNames, {
                                            [styles.variableNamesAligned]: isAligned,
                                        }) }, { children: variables.map(({ key, label }) => isAligned ? (_jsx(Tag, Object.assign({ className: styles.tag }, { children: label }), key)) : (_jsx("div", Object.assign({ className: styles.variableName }, { children: _jsx(VariableToken, { text: label }) }), key))) })), _jsx("div", Object.assign({ className: styles.variableInputs }, { children: variables.map(({ key }) => {
                                            var _a;
                                            return (_jsxs("div", Object.assign({ className: styles.variableInput }, { children: ["\u00A0", '=', "\u00A0", _jsx(RSFieldText, { name: key, value: (_a = variableValues[key]) !== null && _a !== void 0 ? _a : '', onChange: this.onVariableChange }, key)] }), key));
                                        }) }))] })) }))), (hasData || loading) && (_jsxs("div", Object.assign({ className: styles.treeContainer }, { children: [hasData && this.renderTree(data), loading && _jsx(Spinner, {})] }))), hasStatus && (_jsx("div", Object.assign({ className: styles.statusContainer }, { children: status.map(RequestSimulator.renderStatus) })))] })))] })));
    }
}
